import { render, staticRenderFns } from "./mating-view.vue?vue&type=template&id=44643b1a&scoped=true&lang=pug"
import script from "./mating-view.js?vue&type=script&lang=js&external"
export * from "./mating-view.js?vue&type=script&lang=js&external"
import style0 from "./mating-view.vue?vue&type=style&index=0&id=44643b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44643b1a",
  null
  
)

export default component.exports